import React from 'react';
import { FormattedMessage } from 'react-intl';
 
import A from 'components/A';
// import LocaleToggle from 'containers/LocaleToggle';
import Wrapper from './Wrapper';
import messages from './messages';
import { useSelector } from 'react-redux';
 
function Footer() {
  let showFooter = useSelector((store)=>store.loginReducer.showFooter);
  if(showFooter){
    return (
      <div style={{
        display:'block',
        width:'100%',
        position:'fixed',
        bottom:0,
        background:'#4F2D7F',
        textAlign:'center',
        color:'white',
        zIndex:"100",
      }}> @2025-2026 - All right reserved </div>
    );
  }
}
 
export default Footer;
